import { defineComponent } from "vue";
import { mapWritableState } from "pinia";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { Validator } from "@/validator/Validator";
import { useLocationStore } from "@/store/LocationStore";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";
import BaseInput from "@/components/BaseForm/BaseInput/BaseInput.vue";
import BaseSelect from "@/components/BaseForm/BaseSelect/BaseSelect.vue";
import TermsOfUseModal from "@/components/Modals/TermsOfUseModal/TermsOfUseModal.vue";
import IpGeolocationHelper from "@/helpers/IpGeolocation";
import AlertBox from "@/components/AlertBox/AlertBox.vue";
import ThemesHelper from "@/helpers/ThemesHelper";

interface userLocationInterface {
  state: string;
  city: string;
}

export default defineComponent({
  props: {
    active: {
      type: Boolean,
    },
  },
  components: {
    FloatingCard,
    BaseInput,
    BaseSelect,
    TermsOfUseModal,
    AlertBox,
  },
  data() {
    return {
      StepContent: ThemesHelper.getThemeParams("testStepEightContents"),
      states: [{ false: false }],
      cities: [],
      mustAccept: false,
      locationStore: useLocationStore(),
      userLocation: {} as userLocationInterface,
      cpfFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
        { validation: 'validCpf', message: 'Campo aceita apenas CPF válido.' },
      ],
      emailFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
        { validation: 'validEmail', message: 'Campo aceita apenas e-mail válido.' },
      ],
      phoneFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
        { validation: 'validPhone', message: 'Campo aceita apenas telefones válidos.' },
      ],
      stateFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
      ],
      cityFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
      ],
      validField: true,
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
    ...mapWritableState(useRegisterTestStore, ["patient"]),
  },
  watch: {
    patient: {
      handler: function () {
        setTimeout(() => {
          if (this.active) {
            this.canJumpNext = this.isValidForm(false);
          }
        }, 200);
      },
      deep: true,
    },
    'patient.isForeigner'(val) {
      this.validField = (val) ? false : true;
    }
  },
  mounted() {
    this.getStates();
  },
  methods: {
    async getStates() {
      const response: any = await this.locationStore.states();
      this.states = response;
      this.getUserLocation();
    },
    async getCities(stateSelected: any) {
      this.patient.city = '';
      const response: any = await this.locationStore.cities(stateSelected.id);
      this.cities = response;
      this.patient.city = this.userLocation.city;
    },
    async getUserLocation() {
      const location = await IpGeolocationHelper.getUserLocation();
      this.userLocation = location as any;
      this.patient.state = this.userLocation.state;
    },
    errorValidation() {
      this.isValidForm();
    },
    isValidForm(showErrors = true) {
      this.mustAccept = showErrors && !this.patient.accept_terms;
      return (
        Validator.validateForm(this.$refs, showErrors) &&
        this.patient.accept_terms
      );
    },
    isValidStep() {
      return this.isValidForm(false);
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case "setNextDismissAnimation":
            baseModal.setNextDismissAnimation();
            break;
          case "setNextShowAnimation":
            baseModal.setNextShowAnimation();
            break;
          case "setPreviousDismissAnimation":
            baseModal.setPreviousDismissAnimation();
            break;
          case "setPreviousShowAnimation":
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
});
